module.exports = __webpack_public_path__ + "assets/img/1.9e43aec3.jpg";